import React, {useContext, useEffect, useRef, useState} from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {useForm} from "react-hook-form";

import AuthContext from "../../store/auth-context";
import gs from "../../services/global";
import axios from "axios";

import Header from "../../components/Header";
import InnerBgComp from "../../components/InnerBgComp";
import {FlowSteps, hasInstanceId, stepFun, toasterConfig} from "../../utils/Constant";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import {Player} from "@lottiefiles/react-lottie-player";
import animationData from "../../assests/json/loader_full.json";

const {
    REACT_APP_DEVELOPMENTURL,
    REACT_APP_FLOWID,
    REACT_APP_FLOW_URL,
} = process.env;

const DirectDebit = () => {
    const authCtx = useContext(AuthContext);

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const [isCallback] = useState(() => searchParams.get('callback') === '1');
    // The return from GoCardless carries the instance, so it resumes in any browser.
    const [returnInstanceId] = useState(() => searchParams.get('instanceId'));
    const instanceId = returnInstanceId ?? authCtx?.instanceId;
    const [disableBtn, setDisableBtn] = useState(false);
    const [termCheckbox, setTermCheckbox] = useState(false);
    const loaderAnim = useRef(null);
    const animPlay = () => {
        loaderAnim.current.play();
    };

    useEffect(() => {
        if (returnInstanceId && returnInstanceId !== authCtx?.instanceId) {
            authCtx.createInstanceFunc(returnInstanceId);
        }
    }, [returnInstanceId]);

    useEffect(() => {
        if (!isCallback) return;

        // Neither the url nor this browser holds an instance: polling would only hit /instances/null.
        if (!hasInstanceId(instanceId)) {
            toast.error("Your direct debit link has expired.", toasterConfig);
            navigate("/", { replace: true });
            return;
        }

        const interval = setInterval(async () => {
            try {
                let payload = {
                    action: "check",
                    data: {},
                };

                const result = await axios
                    .post(`/flow/${REACT_APP_FLOWID}/instances/${instanceId}`, payload)

                const currentStep = result?.data?.currentStepId;
                const isCompleted = result?.data?.responseData?.completed;

                if (isCompleted === true || currentStep !== FlowSteps.DIRECT_DEBIT) {
                    navigate(stepFun()[currentStep], { replace: true });
                }
            } catch (error) {
                toast.error("Something went wrong.", toasterConfig);
            }
        }, 3000);

        return () => clearInterval(interval);
    }, [isCallback]);


    const {
        handleSubmit,
    } = useForm({
        mode: "all",
    });

    const onSubmit = () => {
        let payload = {
            action: "submit",
            data: {
                // Winter appends callback=1 or error=1 to this url.
                redirectUrl: `${REACT_APP_FLOW_URL}/direct-debit?${new URLSearchParams({ instanceId })}`,
            },
        };

        setDisableBtn(true);
        gs.showLoader(true);

        axios
            .post(`/flow/${REACT_APP_FLOWID}/instances/${instanceId}`, payload)
            .then((response) => {
                const result = response?.data;
                const redirectUrl = result?.responseData?.directDebitAuthorisationUrl;

                if (redirectUrl) {
                    window.location.href = redirectUrl;
                } else {
                    toast.error("Something went wrong.", toasterConfig);
                }

                setDisableBtn(false);
                gs.showLoader(false);
            })
            .catch((error) => {
                const errorEnd = error?.response?.data?.currentStepId;
                navigate(stepFun()[errorEnd], { replace: true });
                const errorResult = error?.response?.data?.errors;
                const arrayOfString = Object.values(errorResult);
                const arrayFlatten = arrayOfString.flat();

                setDisableBtn(false);
                gs.showLoader(false);

                for (let itemData of arrayFlatten) {
                    toast.error(itemData, toasterConfig);
                }
            });
    };

    localStorage.setItem("stUrl", REACT_APP_DEVELOPMENTURL);
    localStorage.setItem("flowId", REACT_APP_FLOWID);

    return (
        <div>
            <Header />
            <div className="main-container">
                <InnerBgComp classes={"inner-bg-img"} />

                <div className="container">
                    {!isCallback && (
                        <motion.div
                            initial={{ y: 60, scale: 0.9, opacity: 0 }}
                            animate={{ y: 0, scale: 1, opacity: 1 }}
                            transition={{ duration: 0.5 }}
                            className="comm-box congo-checkout"
                        >
                            <div className="comm-hdn-slide">
                                <div className="comm-hdn-box">
                                    <h3 className="comm-hdn">Start Direct Debit setup</h3>
                                    <div className="comm-para">
                                        <p>We practice responsible lending by ensuring creditworthiness aligns with Financial Conduct Authority (FCA) guidelines.</p>
                                    </div>
                                </div>
                                <div className="tick-anim">
                                    <i className="icon-check" />
                                </div>
                            </div>
                            <form id="congoForm" onSubmit={handleSubmit(onSubmit)}>
                                <div className="check-box">
                                    <input
                                        type="checkbox"
                                        name="termCheckbox"
                                        id="term"
                                        defaultChecked={termCheckbox}
                                        onClick={(e) => setTermCheckbox(e.target.checked)}
                                    />
                                    <label className="check-label" htmlFor="term">
                                        I agree to be redirected to a third-party for Direct Debit set up.
                                    </label>
                                </div>
                                <button className="button button--block" disabled={!termCheckbox || disableBtn}>Continue</button>
                            </form>
                        </motion.div>
                    )}
                    {isCallback && (
                        <motion.div
                            initial={{ scale: 0, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ duration: 0.5 }}
                            className="comm-box congo-box"
                        >
                            <motion.div
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.5 }}
                                className="congo-lottie"
                            >
                                <Player
                                    onEvent={(event) => {
                                        if (event === "load") {
                                            animPlay();
                                        }
                                    }}
                                    ref={loaderAnim}
                                    autoplay={true}
                                    controls={true}
                                    src={animationData}
                                    keepLastFrame={true}
                                />
                            </motion.div>
                            <div className="congo-cont">
                                <div>
                                    <motion.h4
                                        initial={{ y: 60, opacity: 0 }}
                                        animate={{ y: 0, opacity: 1 }}
                                        transition={{ duration: 0.5 }}
                                        className="congo-hdn"
                                    >
                                        Almost done
                                    </motion.h4>
                                    <motion.div
                                        initial={{ y: 60, opacity: 0 }}
                                        animate={{ y: 0, opacity: 1 }}
                                        transition={{ duration: 0.5, delay: 0.2 }}
                                        className="congo-para"
                                    >
                                        <p>
                                            We are processing your application.
                                            <br /> This won’t take a second
                                        </p>
                                    </motion.div>
                                </div>
                            </div>
                        </motion.div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DirectDebit;